angular.module 'app'
.controller 'HomeController', ($window, $timeout, $scope, $http, $state, $ionicPopup, config, activeUser, ionicMaterialInk) ->
  $scope.ui =
    userInfo: activeUser.user
    baseUrl: config.api.baseUrl
    activeIndex: 0 #为了验证属性active-slide定义的模型，angularjs是mvc模式
    homepage: activeUser.homepage
    slides: []
    columns: []
    topNew: []

  # 此事件对应的是pager-click属性，当显示图片是有对应数量的小圆点，这是小圆点的点击事件
  $scope.pageClick = (index) ->
    $scope.ui.activeIndex = index

  # 当图片切换后，触发此事件，注意参数
  $scope.slideHasChanged = ($index) ->
    # alert($index)

  $scope.toArticle = (article) ->
    $state.go("app.article", {column_id: article.programa_id, article_id: article._id})

  $scope.toTopNew = (topNew) ->
    if topNew.type is 'link'
      $window.open(topNew.link)
    else
      $state.go("app.top_new", {new_id: topNew._id})

  $scope.goMenu = (column) ->
    if column.type is '1' or column.type is '5' or column.type is '6'
      $state.go("app.article_list", {column_id: column._id})

    else if column.type is '2'
      $state.go("app.single_article", {column_id: column._id})

    else if column.type is '3'
      $state.go("app.images", {column_id: column._id})

    else if column.type is '4'
      $state.go("app.external_link", {column_id: column._id})

  do findSlides = ->
    $http.get "#{config.api.baseUrl}/cumpus/headline",
      params:
        limit: 8
        offset: 0
        group_id: activeUser.group_id
        sort: 'sort'
        is_show: true
    .then (res) ->
      $scope.ui.slides = res.data.data
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  do findColumns = ->
    if $scope.ui.homepage.layouts?.length > 0
      _.each $scope.ui.homepage.layouts, (layout) ->
        if layout.is_useing is true
          $scope.ui.columns = _.filter layout.mobileMenusNew, (data) ->
            data if data._id isnt undefined
          $timeout (->
            ionicMaterialInk.displayEffect()
          ), 1000





